module.exports = __webpack_public_path__ + "media/images/countrysquared/ae-0a31f92537551fcd0dfe9a4ed33ef8aa.svg";